//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('helpDocSearch', {
//        templateUrl: 'views/components/views/helpDocSearch/helpDocSearch.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'helpDocSearchService', 'languageService', function (utilityService, helpDocSearchService, languageService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                searchTextButtons: [
//                    { id: 'erase', icon: 'fa fa-eraser', color: 'danger', type: 'danger', onClick: () => clear('searchtext') },
//                    { id: 'search', icon: 'fas fa-search', color: 'primary', type: 'primary', onClick: () => loadHelpDocSearch() }
//                ],
//                setting: {},
//                selectListLanguages: [],
//                itemsListDocuments: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await helpDocSearchService.getHelpDocSearch())[0];
//            }

//            async function loadLanguages() {
//                vm.model.selectListLanguages = await languageService.list();
//            }

//            async function loadHelpDocSearch() {
//                if (utilityService.validateParmsValue(vm.model.setting.language_id) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                return vm.model.itemsListDocuments = await helpDocSearchService.listHelpDocSearch(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region RESET BUTTON FUNCTION

//            function clear(id) {
//                switch (id) {
//                    case 'searchtext':
//                        vm.model.setting.searchtext = '';

//                        if (vm.model.setting.searchtext === '') loadHelpDocSearch();
//                        break;
//                    default:
//                        break;
//                }
//            }

//            // #endregion RESET BUTTON FUNCTION

//            // #region SEARCH & SUBMIT FUNCTION

//            vm.searchItems = function () {
//                loadHelpDocSearch();
//            }

//            // #endregion SEARCH & SUBMIT FUNCTION

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'language_id':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.language_id) !== true) return;

//                        vm.model.setting.language_id = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.language_id) !== true) return;

//                        loadHelpDocSearch();
//                        break;
//                    case 'searchtext':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.searchtext) !== true) return;

//                        vm.model.setting.searchtext = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.searchtext, true) !== true) return;

//                        if (vm.model.setting.searchtext === '') loadHelpDocSearch();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadLanguages();
//                loadHelpDocSearch();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
